import { FC } from "react";

const ActivityListPage: FC = () => {
  return <div>Activities page</div>;
};

export { ActivityListPage };
